// Ionic 6's device detection, kept to its letter so the app's answers don't move: the first answer is cached.
const userAgentMatches = (pattern: RegExp): boolean => pattern.test(window.navigator.userAgent)
const hasCoarsePointer = (): boolean => !!window.matchMedia?.('(any-pointer:coarse)').matches

// iPads that report a Mac user agent count as iOS when the pointer is coarse.
const detectIOS = (): boolean =>
	userAgentMatches(/iPhone|iPod/i) ||
	userAgentMatches(/iPad/i) ||
	(userAgentMatches(/Macintosh/i) && hasCoarsePointer())

let detected: { ios: boolean; desktop: boolean } | undefined

const detect = () => (detected ??= { ios: detectIOS(), desktop: !hasCoarsePointer() })

export const isIOSDevice = (): boolean => detect().ios

export const isDesktopDevice = (): boolean => detect().desktop

export const resetDeviceDetectionForTests = (): void => {
	detected = undefined
}
